/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SocieteExterneEditDto
 */
export interface SocieteExterneEditDto {
    /**
     * 
     * @type {number}
     * @memberof SocieteExterneEditDto
     */
    idsocieteExterne?: number;
    /**
     * 
     * @type {string}
     * @memberof SocieteExterneEditDto
     */
    nom?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SocieteExterneEditDto
     */
    idsMetier?: Array<number> | null;
}

/**
 * Check if a given object implements the SocieteExterneEditDto interface.
 */
export function instanceOfSocieteExterneEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SocieteExterneEditDtoFromJSON(json: any): SocieteExterneEditDto {
    return SocieteExterneEditDtoFromJSONTyped(json, false);
}

export function SocieteExterneEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocieteExterneEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsocieteExterne': !exists(json, 'idsocieteExterne') ? undefined : json['idsocieteExterne'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'idsMetier': !exists(json, 'idsMetier') ? undefined : json['idsMetier'],
    };
}

export function SocieteExterneEditDtoToJSON(value?: SocieteExterneEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsocieteExterne': value.idsocieteExterne,
        'nom': value.nom,
        'idsMetier': value.idsMetier,
    };
}

